import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import formatTemplate from 'properties/main/url.ejs';


class MainUrlView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]' : 'updateAttributes',
            'click #compose_button' : 'compose'
        };

        // Add needed property
        if (!this.model.get('urlChoice')) {
            this.model.set('urlChoice', 'text', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    compose() {
        //TODO : formula compose code
        console.log('formula compose code.');
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    render() {
        // console.log(this.model.attributes);
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const urlChoice = this.model.get('urlChoice');

        if(urlChoice === 'special') {
            $('#special').prop('disabled', false);
        }
        if(urlChoice === 'text') {
            $('#text_value').prop('disabled', false);
        }
        if(urlChoice === 'field_value') {
            $('#field_value').prop('disabled', false);
            $('#selectField').prop('disabled', false);
        }
        if(urlChoice === 'formula') {
            $('#compose_button').prop('disabled', false);
        }

        $('input[name=urlChoice][value="'+this.model.get('urlChoice')+'"]').prop('checked', true);
        
        this.delegateEvents();
        return this;
    }

}

export default MainUrlView;
